import type { Translate } from "@similarweb/i18n-provider";
import { TruncatedTextCell, type ColumnsType } from "@similarweb/pro-logic-components";

import { stringSorter } from "app/pages/sales-intelligence/utils/sort";

import type { TeamListItem } from "../../types/teams.types";

import { TeamsTableActionsCell } from "./TeamsTableActionsCell";
import { TeamsTableFiltersCell } from "./TeamsTableFiltersCell";
import { TeamsTableMembersCell } from "./TeamsTableMembersCell";
import { TeamsTableNameCell } from "./TeamsTableNameCell";
import { TeamsTableScoringCell } from "./TeamsTableScoringCell";

export type TeamsColumnHandlers = {
    onEdit: (team: TeamListItem) => void;
    onDelete: (team: TeamListItem) => void;
};

export const getTeamsColumns = (translate: Translate, handlers: TeamsColumnHandlers): ColumnsType<TeamListItem> => [
    {
        dataIndex: "name",
        title: translate("si.management.teams.column.name"),
        sorter: stringSorter("name"),
        width: 280,
        render: (_value, record) => <TeamsTableNameCell team={record} />,
    },
    {
        dataIndex: "description",
        title: translate("si.management.teams.column.description"),
        sorter: stringSorter("description"),
        width: 300,
        render: (_value, record) => <TruncatedTextCell>{record.description || "-"}</TruncatedTextCell>,
    },
    {
        dataIndex: "membersCount",
        title: translate("si.management.teams.column.members"),
        width: 200,
        render: (_value, record) => <TeamsTableMembersCell team={record} />,
    },
    {
        key: "territoryFilters",
        title: translate("si.management.teams.column.territory_filters"),
        width: 180,
        render: (_value, record) => <TeamsTableFiltersCell team={record} />,
    },
    {
        key: "leadScoring",
        title: translate("si.management.teams.column.lead_scoring"),
        width: 180,
        render: (_value, record) => <TeamsTableScoringCell team={record} />,
    },
    {
        key: "actions",
        title: "",
        width: 108,
        render: (_value, record) => (
            <TeamsTableActionsCell
                team={record}
                onEdit={handlers.onEdit}
                onDelete={handlers.onDelete}
            />
        ),
    },
];
